import * as v from 'common/validators';

export const dobFieldsValidate = values => ({
  day:
    v.required(values.day) ||
    v.minValue(1)(values.day) ||
    v.maxValue(31)(values.day),
  month:
    v.required(values.month) ||
    v.minValue(1)(values.month) ||
    v.maxValue(12)(values.month),
  year: v.required(values.year) || v.minValue(1900)(values.year),
});

export const nameFieldsValidate = values => ({
  first_name: v.required(values.first_name),
  last_name: v.required(values.last_name),
});

export const addressFieldsValidate = values => ({
  address1: v.required(values.address1),
  city: v.required(values.city),
  state: values.state
    ? undefined
    : v.required(values.state) ||
      v.state(gon.CURRENT_COUNTRY_STATES)(values.state),
  ssn: values.ssn_optout
    ? undefined
    : v.required(values.ssn) || v.minLength(4)(values.ssn),
});

export const dobNameValidate = values => ({
  ...dobFieldsValidate(values),
  ...nameFieldsValidate(values),
});

export const addressValidate = values => ({
  ...dobFieldsValidate(values),
  ...nameFieldsValidate(values),
  ...addressFieldsValidate(values),
});

export const alternateAddressValidate = values => ({
  ...nameFieldsValidate(values),
  ...addressFieldsValidate(values),
});



// WEBPACK FOOTER //
// ./app/javascript/apps/age_verification/components/forms/validations.js